module.exports = __webpack_public_path__ + "img/newzeland.0762a124.svg";